// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2KPBW","choiceBoxes":"toolbarselects_choiceBoxes__3ju0E","simpleField":"toolbarselects_simpleField__avT9g"};